import * as $ from 'jquery';

/**
 * EqualHeightGridController
 *
 * @author Felix König <f.koenig@andersundsehr.com>
 */
export default class EqualHeightGridController {
  private itemSelector = '.js-equalHeight';
  private timeOut = 200;
  private isWaiting = false;

  /**
   * Public function to init class
   */
  constructor() {
    if ($(this.itemSelector).length > 0) {
      this.update();
      this.updateSlider();
      // add extra timeout for safari
      if ($('html').hasClass('safari')) {
        this.timeOut = 500;
      }

      $(window).resize(() => {
        if (!this.isWaiting) {
          this.isWaiting = true;

          window.setTimeout(
            () => {
              this.update();
              this.updateSlider();
              this.isWaiting = false;
            },
            this.timeOut,
          );
        }
      });
    }
  }

  update() {
    if ($('.js-equalHeightWrapper').length > 0) {
      $('.js-equalHeightWrapper').each((index, elem) => {
        const $this = $(elem);
        const columnItems = $this.find(this.itemSelector);
        columnItems.css('height', 'auto');
        this.getEqualHeight(columnItems);
      });
    } else {
      // this.getEqualHeightAll();
    }
  }

  // this update function is for the slider
  updateSlider() {
    if ($('.js-slideWrapper').length > 0) {
      $('.js-slideWrapper').each((index, elem) => {
        const $this = $(elem);
        const columnItemsSlider = $this.find(this.itemSelector);
        columnItemsSlider.css('height', 'auto');
        this.getEqualHeightSlider(columnItemsSlider);
      });
    }
  }

  getEqualHeight(columnItems) {
    let highestColumn = 0;
    $(columnItems).each((index, elem) => {
      const $this = $(elem);
      const height = $this.height();
      if (height && height > highestColumn) {
        highestColumn = height;
      }
    });
    $(columnItems).height(highestColumn);
  }

  // equal height for testimonial Slider only
  getEqualHeightSlider(columnItemsSlider) {
    let highestColumn = 0;
    let extraSpace = 0;
    const width = $(window).width();
    if (width && width > 768) {
      extraSpace = 100;
    } else if (width && width > 425) {
      extraSpace = 450;
    } else {
      extraSpace = 300;
    }
    if ($('.tx-rampftestimonial').length) {
      $(columnItemsSlider).each((index, elem) => {
        const $this = $(elem);
        const outerHeight = $this.outerHeight();
        if (outerHeight && outerHeight > highestColumn) {
          highestColumn = outerHeight;
          $(columnItemsSlider).closest('.js-testimonialItem').height(highestColumn + extraSpace);
        }
      });
    }
  }
}
